import React from 'react'
import { render } from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'
import configureStore from './configureStore'
import { saveState } from './localStorage'
import { debounce } from './utils'

const store = configureStore()

//Save localstorage
store.subscribe(debounce(function () {
    saveState(store.getState())
}, 1000))

render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
)